import React from "react";
import { Button, Form, Col, Row } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import { useSelector } from "react-redux";
import { selectSelected } from "./invoiceOldSlice";
import { useHistory } from "react-router-dom";
import { formatDate,formatCurrency } from "../../../utility";

export const InvoiceOldDetail = () => {
  const history = useHistory();
  const items = useSelector(selectSelected);

  // Return if data null
  if (items === null) {
    history.push("/master/sap-invoice-old");
  }

  return items === null ? null : (
    <Card>
      <CardHeader title="Invoice Old Detail"></CardHeader>
      <CardBody>
      <Form>
            <Form.Group as={Row}>
              {/* kanan */}
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Client Year</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control value={items.principalYear} disabled />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Priode Nor</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control value={items.periodNo} disabled />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Transaction Date</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control value={formatDate(items.transactionDate)} disabled />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Client Code</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control value={items.principalCode} disabled />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Client Name</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control value={items.principalName} disabled />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Business Division 1</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      value={items.businessDivision1}
                      disabled
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Business Division 2</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      value={items.businessDivision2}
                      disabled
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Invoice Ref Num</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control value={items.invoiceNo} disabled />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Material Code</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control value={items.zpItemCode} disabled />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Material Name</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control value={items.itemName} disabled />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Plant Name</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control value={items.branch} disabled />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Cust Group 1 Code</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control value={items.custGroup1Code} disabled />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Channel</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control value={items.channel} disabled />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Customer Type</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control value={items.customerType} disabled />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Customer Code</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control value={items.customerCode} disabled />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Customer Name</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control value={items.customerName} disabled />
                  </Col>
                </Form.Group>
              </Col>
              {/* kiri */}
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>List Price A</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control value={formatCurrency(items.listPriceA)} disabled />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Uom</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control value={items.uom} disabled />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Sales Unit</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control value={formatCurrency(items.salesUnit)} disabled />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Net Sales</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control value={formatCurrency(items.netSales)} disabled />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Discount Client</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      value={items.discountPrincipal}
                      disabled
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Sales Value</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control value={formatCurrency(items.salesValue)} disabled />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Bonus Value</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control value={items.bonusValue} disabled />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Bonus Unit</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control value={items.bonusUnit} disabled />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Zip Code</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control value={items.zipCode} disabled />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>PO</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control value={items.PO} disabled />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Address</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control value={items.address} disabled />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Store Location</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control value={items.storeLocation} disabled />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Batch</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control value={items.batch} disabled />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Expired Date</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control value={formatDate(items.expiredDate)} disabled />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>New Plant Code</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control value={items.newPlant} disabled />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Tax Invoice Number</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control value={items.taxInvoice} disabled />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Remaining Qty</b>
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control placeholder="Input" />
                  </Col>
                </Form.Group>
              </Col>
            </Form.Group>
          </Form>
        <Row className="mt-6">
          <Button
            variant="light"
            className="mr-3"
            onClick={() => history.push("/master/sap-invoice-old")}
          >
            <i className="fa fa-arrow-left" />
            Back
          </Button>
        </Row>
      </CardBody>
    </Card>
  );
};
